import { ElementType, type ItemDetails, type ItemType, type LegacySegmentTypes, Track } from '@1debit/analytics';
import { useCallback } from 'react';

import { useAnalytics } from './useAnalytics';

export type BannerAnalyticsData = {
	unique_id: string;
	item_type: LegacySegmentTypes.ItemType;
	item_id: string;
	legacy_item_details?: string;
	item_details?: ItemDetails;
	item_value?: string;
} | null;

export function useBannerShownAnalytics(analyticsData: BannerAnalyticsData) {
	const analytics = useAnalytics();

	const handleBannerShown = useCallback(() => {
		if (analytics && analyticsData) {
			const { unique_id, item_id, item_details, legacy_item_details, item_type, item_value } = analyticsData;
			analytics.handler.trackBannerShown({
				unique_id,
				item_type: item_type,
				item_id: item_id,
				item_details: legacy_item_details,
			});

			analytics.handler.trackEvent(Track.WebItemViewed, {
				unique_id: unique_id,
				element_type: ElementType.ELEMENT_TYPE_BANNER,
				// [Temporary until we finish event migration] We are casting here because we know that the types are the same
				item_type: item_type as ItemType,
				item_id: item_id,
				item_value: item_value,
				item_details: item_details,
			});
		}
	}, [analytics, analyticsData]);

	return {
		handleBannerShown,
	};
}
